module.exports = __webpack_public_path__ + "static/media/header-map.4b163b87.png";